import rank1Png from '/img/leagues/badge-1.png';
import rank1Webp from '/img/leagues/badge-1.webp';
import rank2Png from '/img/leagues/badge-2.png';
import rank2Webp from '/img/leagues/badge-2.webp';
import rank3Png from '/img/leagues/badge-3.png';
import rank3Webp from '/img/leagues/badge-3.webp';
import rank4Png from '/img/leagues/badge-4.png';
import rank4Webp from '/img/leagues/badge-4.webp';
import rank5Png from '/img/leagues/badge-5.png';
import rank5Webp from '/img/leagues/badge-5.webp';
import rank6Png from '/img/leagues/badge-6.png';
import rank6Webp from '/img/leagues/badge-6.webp';
import rank7Png from '/img/leagues/badge-7.png';
import rank7Webp from '/img/leagues/badge-7.webp';
import rank8Png from '/img/leagues/badge-8.png';
import rank8Webp from '/img/leagues/badge-8.webp';
import rank9Png from '/img/leagues/badge-9.png';
import rank9Webp from '/img/leagues/badge-9.webp';
import rank10Png from '/img/leagues/badge-10.png';
import rank10Webp from '/img/leagues/badge-10.webp';
import bronzeCupPng from '/img/leagues/bronze.png';
import bronzeCupWebp from '/img/leagues/bronze.webp';
import bronzeChestPng from '/img/leagues/bronze-chests.png';
import bronzeChestWebp from '/img/leagues/bronze-chests.webp';
import bronzeChestLargePng from '/img/leagues/bronze-chests-large.png';
import bronzeChestLargeWebp from '/img/leagues/bronze-chests-large.webp';
import defaultChestPng from '/img/leagues/default-chests.png';
import defaultChestWebp from '/img/leagues/default-chests.webp';
import defaultChestLargePng from '/img/leagues/default-chests-large.png';
import defaultChestLargeWebp from '/img/leagues/default-chests-large.webp';
import goldCupPng from '/img/leagues/gold.png';
import goldCupWebp from '/img/leagues/gold.webp';
import goldChestPng from '/img/leagues/gold-chests.png';
import goldChestWebp from '/img/leagues/gold-chests.webp';
import goldChestLargePng from '/img/leagues/gold-chests-large.png';
import goldChestLargeWebp from '/img/leagues/gold-chests-large.webp';
import otherChestPng from '/img/leagues/other-chests.png';
import otherChestWebp from '/img/leagues/other-chests.webp';
import otherChestLargePng from '/img/leagues/other-chests-large.png';
import otherChestLargeWebp from '/img/leagues/other-chests-large.webp';
import silverCupPng from '/img/leagues/silver.png';
import silverCupWebp from '/img/leagues/silver.webp';
import silverChestPng from '/img/leagues/silver-chests.png';
import silverChestWebp from '/img/leagues/silver-chests.webp';
import silverChestLargePng from '/img/leagues/silver-chests-large.png';
import silverChestLargeWebp from '/img/leagues/silver-chests-large.webp';
import rank10MedalPng from '/img/leagues/top-10-medal.png';
import rank10MedalWebp from '/img/leagues/top-10-medal.webp';
import rank20MedalPng from '/img/leagues/top-20-medal.png';
import rank20MedalWebp from '/img/leagues/top-20-medal.webp';
import rank30MedalPng from '/img/leagues/top-30-medal.png';
import rank30MedalWebp from '/img/leagues/top-30-medal.webp';
import rank50MedalPng from '/img/leagues/top-50-medal.png';
import rank50MedalWebp from '/img/leagues/top-50-medal.webp';
import rank100MedalPng from '/img/leagues/top-100-medal.png';
import rank100MedalWebp from '/img/leagues/top-100-medal.webp';

const leagueRankImages: Record<string, { png: string; webp: string }> = {
  'Wood League': {
    png: rank1Png,
    webp: rank1Webp,
  },
  'Steel League': {
    png: rank2Png,
    webp: rank2Webp,
  },
  'Bronze League': {
    png: rank3Png,
    webp: rank3Webp,
  },
  'Silver League': {
    png: rank4Png,
    webp: rank4Webp,
  },
  'Gold League': {
    png: rank5Png,
    webp: rank5Webp,
  },
  'Platinum League': {
    png: rank6Png,
    webp: rank6Webp,
  },
  'Diamond League': {
    png: rank7Png,
    webp: rank7Webp,
  },
  'Titanium League': {
    png: rank8Png,
    webp: rank8Webp,
  },
  'Technogem League': {
    png: rank9Png,
    webp: rank9Webp,
  },
  'Imperial League': {
    png: rank10Png,
    webp: rank10Webp,
  },
};

const leagueClassNames: Record<string, string> = {
  'Wood League': 'wood',
  'Steel League': 'steel',
  'Bronze League': 'bronze',
  'Silver League': 'siver',
  'Gold League': 'gold',
  'Platinum League': 'platinum',
  'Diamond League': 'diamond',
  'Titanium League': 'titanium',
  'Technogem League': 'technogem',
  'Imperial League': 'imperial',
};

const leagueNames: Record<string, string> = {
  1: 'Wood League',
  2: 'Steel League',
  3: 'Bronze League',
  4: 'Silver League',
  5: 'Gold League',
  6: 'Platinum League',
  7: 'Diamond League',
  8: 'Titanium League',
  9: 'Technogem League',
  10: 'Imperial League',
};

const infoText: Record<number, string> = {
  0: 'The more Star Points you earn during the event, the higher you rank in the leaderboard!',
  1: 'Complete at least one contract during the event to join. Rewards depend on your league',
  2: 'You can advance to the next league by increasing your Empire’s Capitalization',
  3: 'Earn Event EXP — your activity will be rewarded during the TGE',
  4: 'Advancing to the next league is only possible after the active event ends',
};

const cupImages = {
  gold: {
    png: goldCupPng,
    webp: goldCupWebp,
  },
  silver: {
    png: silverCupPng,
    webp: silverCupWebp,
  },
  bronze: {
    png: bronzeCupPng,
    webp: bronzeCupWebp,
  },
};
const chestImages = {
  gold: {
    png: goldChestPng,
    webp: goldChestWebp,
  },
  silver: {
    png: silverChestPng,
    webp: silverChestWebp,
  },
  bronze: {
    png: bronzeChestPng,
    webp: bronzeChestWebp,
  },
  default: {
    png: defaultChestPng,
    webp: defaultChestWebp,
  },
  other: {
    png: otherChestPng,
    webp: otherChestWebp,
  },
};

const largeChestImages = {
  gold: {
    png: goldChestLargePng,
    webp: goldChestLargeWebp,
  },
  silver: {
    png: silverChestLargePng,
    webp: silverChestLargeWebp,
  },
  bronze: {
    png: bronzeChestLargePng,
    webp: bronzeChestLargeWebp,
  },
  default: {
    png: defaultChestLargePng,
    webp: defaultChestLargeWebp,
  },
  other: {
    png: otherChestLargePng,
    webp: otherChestLargeWebp,
  },
};

const rankMedalIcons = {
  '10': {
    png: rank10MedalPng,
    webp: rank10MedalWebp,
  },
  '20': {
    png: rank20MedalPng,
    webp: rank20MedalWebp,
  },
  '30': {
    png: rank30MedalPng,
    webp: rank30MedalWebp,
  },
  '40': {
    png: rank50MedalPng,
    webp: rank50MedalWebp,
  },
  '50': {
    png: rank50MedalPng,
    webp: rank50MedalWebp,
  },
  '75': {
    png: rank100MedalPng,
    webp: rank100MedalWebp,
  },
  '100': {
    png: rank100MedalPng,
    webp: rank100MedalWebp,
  },
};

export {
  chestImages,
  cupImages,
  infoText,
  largeChestImages,
  leagueClassNames,
  leagueNames,
  leagueRankImages,
  rankMedalIcons,
};
